import { useEffect, useState } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export interface VehiclePayload {
  lat: number;
  lng: number;
  status?: string;
  geofence_id?: string;
  geofence_name?: string;
  timestamp?: string;
}

declare global {
  interface Window {
    Pusher: any;
  }
  var api_url: string; 
}

export const useVehicleTracking = (vehicleId: string | null, token: string | null) => {
  const [livePosition, setLivePosition] = useState<VehiclePayload | null>(null);
  const [isConnected, setIsConnected] = useState(false);
  
  const params = new URLSearchParams(window.location.search);
  const userId = params.get('user_id');

  useEffect(() => {
    if (!vehicleId || !token) {
      console.warn("⚠️ Tracking WS: Missing vehicleId or token");
      return;
    }

    window.Pusher = Pusher;

    const echo = new Echo({
      broadcaster: 'pusher',
      key: '1bb714350e7e2ec6e90a',
      cluster: 'ap2',
      wsHost: new URL(global.api_url).hostname,
      wssPort: 443,
      forceTLS: true,
      disableStats: true,
      enabledTransports: ['ws'],
      authEndpoint: `${global.api_url}/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    });

    echo.connector.pusher.connection.bind('connected', () => {
      console.log('✅ Tracking Soketi Connected!');
      setIsConnected(true);
    });

    echo.connector.pusher.connection.bind('error', (err: any) => {
      console.error('❌ Tracking Soketi Error:', err);
    });

    echo.connector.pusher.connection.bind('disconnected', () => {
      console.warn('⚠️ Tracking Soketi Disconnected.');
      setIsConnected(false);
    });

    const channelName = `App.Models.User.${userId}`; 
    const channel = echo.private(channelName);
    
    channel.listen('.location.update', (payload: any) => { 
      console.log("📍 Live Location received via Soketi:", payload);
      if (payload && typeof payload.lat === 'number' && typeof payload.lng === 'number') {
        setLivePosition(payload);
      }
    });

    return () => {
      channel.stopListening('.location.update');
      echo.leave(channelName);
      echo.disconnect();
    };
  }, [vehicleId, token, userId]);

  return { livePosition, isConnected };
};